"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _index = require("../../../utils/styles/index");
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */

/* ++++++++++ --------------- EXPORT : NAV LINKS : STYLES --------------- ++++++++++ */


var _default = {
  nav: {
    // subnav
    '&.name-subnav': {
      background: _index.theme.color.supporting.light.swatch,
      padding: (0, _index.replacePXinStringWithEM)("13px ".concat(_index.theme.spacing.sides)),
      borderBottom: (0, _index.replacePXinStringWithEM)("1px solid ".concat(_index.theme.color.grey.medium.swatch)),
      // animation
      opacity: '0',
      animationName: 'fadeInLeft',
      animationDelay: '.1s',
      animationDuration: '.2s',
      animationFillMode: 'forwards'
    }
  }
};
exports.default = _default;